module.exports = __webpack_public_path__ + "img/repnxtno.b5771864.svg";